import { buildApiUrl } from './apiUrl';

const getTrackingApiUrl = (path) => {
    if (typeof window !== 'undefined' && window.location) {
        const hostname = String(window.location.hostname || '').toLowerCase();
        if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1') {
            return `http://localhost:5000${path}`;
        }
    }

    const configuredBase = process.env.REACT_APP_API_BASE || '';
    if (configuredBase) {
        return `${configuredBase.replace(/\/$/, '')}${path}`;
    }

    return buildApiUrl(path);
};

const trackVisitor = async (category = 'rentals', bid = "HOME", comments = "") => {

    let latitude = "";
    let longitude = "";
    let cityname = "";
    let region = "";
    let countryname = "";

    // Try GPS (requires permission)
    if (navigator.geolocation) {
        try {
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(
                    resolve,
                    reject,
                    {
                        timeout: 5000,
                        maximumAge: 0
                    }
                );
            });

            latitude = position.coords.latitude;
            longitude = position.coords.longitude;

        } catch (err) {
            console.log("GPS Permission Denied");
        }
    }

    // Try IP-based geolocation for city/region/country
    try {
        const response = await fetch('https://ipapi.co/json/');
        if (response.ok) {
            const geoData = await response.json();
            cityname = geoData.city || "";
            region = geoData.region || "";
            countryname = geoData.country_name || geoData.country || "";
        }
    } catch (err) {
        console.log("IP geolocation lookup failed", err);
    }

    try {

        await fetch(getTrackingApiUrl('/api/trackvisitor'), {

            method: "POST",

            headers: {
                "Content-Type": "application/json"
            },

            body: JSON.stringify({

                category,

                bid,

                comments,

                latitude,

                longitude,

                cityname,

                region,

                countryname

            })

        });

    } catch (err) {
        console.log(err);
    }

};

export default trackVisitor;
